import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ConfirmableIconButton from 'components/ConfirmableIconButton';
import Dialog from 'components/Dialog';
import PackageDateAddFlightDialog from 'components/PackageDateAddFlightDialog';
import CopyFlightButton from 'components/CopyFlightButton';

import { useRemoveFlight } from 'lib';

import { PackageEditTransportFlightsRowActions_packageDate$key } from '__generated__/PackageEditTransportFlightsRowActions_packageDate.graphql';
import { PackageEditTransportFlightsRowActions_data$key } from '__generated__/PackageEditTransportFlightsRowActions_data.graphql';
import { PackageEditTransportFlightsRowActions_package$key } from '__generated__/PackageEditTransportFlightsRowActions_package.graphql';

type Props = {
  packageDate: PackageEditTransportFlightsRowActions_packageDate$key;
  data: PackageEditTransportFlightsRowActions_data$key;
  package: PackageEditTransportFlightsRowActions_package$key;
};

const PackageEditTransportFlightsRowActions: FC<Props> = props => {
  const packageDate = useFragment(
    graphql`
      fragment PackageEditTransportFlightsRowActions_packageDate on PackageDate {
        id

        flight {
          id
        }

        ...PackageDateAddFlightDialog_packageDate
        ...CopyFlightButton_packageDate
      }
    `,
    props.packageDate
  );

  const data = useFragment(
    graphql`
      fragment PackageEditTransportFlightsRowActions_data on Query {
        ...PackageDateAddFlightDialog_data
      }
    `,
    props.data
  );

  const pack = useFragment(
    graphql`
      fragment PackageEditTransportFlightsRowActions_package on Package {
        ...PackageDateAddFlightDialog_package
      }
    `,
    props.package
  );

  const { id, flight } = packageDate;
  const [removeFlight] = useRemoveFlight(id);

  return (
    <Box sx={{ display: 'flex' }}>
      {flight && (
        <Tooltip title="Šalinti skrydį">
          <span>
            <ConfirmableIconButton size="small" onConfirm={removeFlight}>
              <DeleteIcon fontSize="small" />
            </ConfirmableIconButton>
          </span>
        </Tooltip>
      )}

      <CopyFlightButton packageDate={packageDate} />

      {!flight && (
        <Dialog
          fullWidth
          maxWidth="md"
          activateButton={open => (
            <Tooltip title="Pridėti">
              <span>
                <IconButton size="small" color="primary" onClick={open}>
                  <AddCircleIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          )}>
          <PackageDateAddFlightDialog
            autoStart
            packageDate={packageDate}
            data={data}
            package={pack}
          />
        </Dialog>
      )}
    </Box>
  );
};

export default PackageEditTransportFlightsRowActions;
